import * as pxp from 'lib/pxp'

/**
 * FEAT. : Guest Flow Revamp
 * Guest 2.0 Ramping is divided into Main Elmo and Features Elmo.
 * 
 * Main Elmo: 
 * This is to control the ramp between Guest1.0(old flow) and Guest2.0(new flow).
 * https://internal.msmaster.qa.paypal.com/elmo/experiment/119985
 *
 * Features Elmo:
 * This Elmo contains the ramping of features for each country within Guest2.0.
 * https://internal.msmaster.qa.paypal.com/elmo/experiment/119989

Production: 
 * https://admin.paypalinc.com/elmo/experiment/104994 (Main)
 * https://admin.paypalinc.com/elmo/experiment/104995 (Features)
 */

/**
 * FEAT. : Guest Flow Revamp - Non-regulatory forced signup
 * Guest2.0 Non-regulatory Forced Signup feature where users would always see the Signup link.
 * Elmo links can be found in the documentation section of hasGuestFlowRevamp() function.
 */
export function hasGuestRevampForcedSignup() {
  return pxp.isTreatment(
    'Trmt_p2p_guest_revamp_features_non_regulatory_forced_signup'
  )
}

/**
 * FEAT. : Guest Flow Revamp - All Guest only countries.
 * Guest2.0 All countries where users can only pay as Guest and cannot choose to become members from Guest Pay flow.
 * Elmo links can be found in the documentation section of hasGuestFlowRevamp() function.
 */
export function hasGuestFlowRevampForGuestOnlyCountries() {
  return pxp.isTreatment('Trmt_p2p_guest_revamp_features_guest_only_countries')
}

/**
 * FEAT. : Guest Flow Revamp - All Member Only countries.
 * Guest2.0 All countries where users can only become members when they click on the Guest Pay Request.
 * Elmo links can be found in the documentation section of hasGuestFlowRevamp() function.
 */
export function hasGuestFlowRevampForMemberOnlyCountries() {
  return pxp.isTreatment('Trmt_p2p_guest_revamp_features_member_only_countries')
}

/**
 * FEAT. : Guest Flow Revamp - Member toggle default value
 * Guest2.0 Sets default value enabled/disabled (true/false) for member toggle when is NOT guest only and is NOT forced to signup
 */
export function hasGuestFlowRevampMemberToggleDisabled() {
  return pxp.isTreatment('p2p_guest_revamp_member_toggle_disabled')
}
